import { motion } from 'framer-motion';

interface MonthlySpending {
  month: string;
  amount: number;
  maxAmount: number;
}

interface MonthlySpendingBoxProps {
  monthlySpending: MonthlySpending[];
}

export const MonthlySpendingBox = ({ monthlySpending }: MonthlySpendingBoxProps) => {
  const topMonth = monthlySpending.reduce((max, current) => 
    current.amount > max.amount ? current : max
  );

  return (
    <div className="relative">
      {/* Shadow box */}
      <div className="absolute top-[4px] left-[4px] w-full h-full bg-black rounded-xl" />
      
      {/* Main content box */}
      <div className="bg-white rounded-xl p-4 relative border-2 border-black">
        <div className="text-[#221A51]/60 text-sm mb-3">Biggest Month</div>
        <div className="space-y-2">
          <div className="flex items-center">
            <div className="font-medium text-[#221A51] text-base">
              {topMonth.month}
            </div>
            <div className="font-semibold text-[#221A51] text-base ml-4">
              ${topMonth.amount.toLocaleString()}
            </div>
          </div>

          <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${(topMonth.amount / topMonth.maxAmount) * 100}%` }}
              transition={{ duration: 1 }}
              className="h-full bg-[#9B86EA] rounded-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
